"use strict";

exports.__esModule = true;
exports.YAxisDomainFieldsHeader = exports.MinMaxNumericInput = exports.FieldSelectorButton = exports.AxisControls = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AxisControls = exports.AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "styles__AxisControls",
  componentId: "sc-r7dfmw-0"
})(["display:flex;label{flex:1;}"]);
var MinMaxNumericInput = exports.MinMaxNumericInput = (0, _styledComponents["default"])(_core.NumericInput).withConfig({
  displayName: "styles__MinMaxNumericInput",
  componentId: "sc-r7dfmw-1"
})([".", "{width:75px;margin-right:1em;}"], _core.Classes.INPUT_GROUP);
var FieldSelectorButton = exports.FieldSelectorButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "styles__FieldSelectorButton",
  componentId: "sc-r7dfmw-2"
})([".", "{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;}"], _core.Classes.BUTTON_TEXT);
var YAxisDomainFieldsHeader = exports.YAxisDomainFieldsHeader = _styledComponents["default"].div.withConfig({
  displayName: "styles__YAxisDomainFieldsHeader",
  componentId: "sc-r7dfmw-3"
})(["font-weight:", ";margin-bottom:8px;"], (0, _Theme.val)("fontWeightHeavy"));